import React, { useState } from 'react';
import './App.css';
import ChatInterface from './components/ChatInterface';
import ManagerApproval from './components/ManagerApproval';

function App() {
  const [view, setView] = useState('user'); // 'user' or 'manager'
  const [requestData, setRequestData] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);

  const handleRequestCreated = (data) => {
    setRequestData(data);
  };

  const handleApproval = (approval) => {
    setApprovalStatus(approval);
  };

  return (
    <div className="App">
      <div className="app-header">
        <div className="branding">
          <h1>AI-Powered VM Provisioning</h1>
          <span className="company-name">XORIANT</span>
        </div>
        <p className="app-subtitle">Intelligent Infrastructure Automation</p>
      </div>

      <div className="view-switcher">
        <button
          className={view === 'user' ? 'active' : ''}
          onClick={() => setView('user')}
        >
          👤 User View
        </button>
        <button
          className={view === 'manager' ? 'active' : ''}
          onClick={() => setView('manager')}
        >
          👔 Manager View
        </button>
      </div>

      <div style={{ display: view === 'user' ? 'block' : 'none' }}>
        <ChatInterface
          onRequestCreated={handleRequestCreated}
          approvalStatus={approvalStatus}
        />
      </div>
      <div style={{ display: view === 'manager' ? 'block' : 'none' }}>
        <ManagerApproval
          requestData={requestData}
          onApproval={handleApproval}
        />
      </div>
    </div>
  );
}

export default App;
